import { Form, Grid, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { type FC } from 'react';

import { EditPhoneInput } from '../../../../../components/EditPhoneInput/EditPhoneInput';
import { messages } from './ContactInformationSection.messages';
import type { ContactInformationSectionProps } from './ContactInformationSection.types';

export const ContactInformationSection: FC<ContactInformationSectionProps> = (props) => {
    const { qa } = props;

    return (
        <Form.Part>
            <Grid gap={24}>
                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    <TextField
                        required
                        name='name'
                        qa={domHelpers.generateDataQa(qa, 'name')}
                        label={messages.nameLabel}
                        placeholder={messages.namePlaceholder}
                        maxLength={constants.xeroConstants.CONTACT_NAME_MAX_LENGTH}
                    />

                    <TextField
                        name='accountNumber'
                        qa={domHelpers.generateDataQa(qa, 'account-number')}
                        label={messages.accountNumber}
                        placeholder={messages.accountNumberPlaceholder}
                        maxLength={constants.xeroConstants.ACCOUNT_NUMBER_MAX_LENGTH}
                    />

                    <TextField
                        name='firstName'
                        qa={domHelpers.generateDataQa(qa, 'first-name')}
                        label={messages.firstNameLabel}
                        placeholder={messages.firstNamePlaceholder}
                        maxLength={constants.xeroConstants.FIRST_NAME_MAX_LENGTH}
                    />

                    <TextField
                        name='lastName'
                        qa={domHelpers.generateDataQa(qa, 'last-name')}
                        label={messages.lastNameLabel}
                        placeholder={messages.lastNamePlaceholder}
                        maxLength={constants.xeroConstants.LAST_NAME_MAX_LENGTH}
                    />

                    <TextField
                        name='email'
                        qa={domHelpers.generateDataQa(qa, 'email')}
                        label={messages.emailLabel}
                        placeholder={messages.emailPlaceholder}
                        maxLength={constants.xeroConstants.EMAIL_ADDRESS_MAX_LENGTH}
                    />
                </Grid>

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    <EditPhoneInput name='phone' label={messages.phoneLabel} qa={qa} />

                    <EditPhoneInput name='fax' label={messages.faxLabel} qa={qa} />

                    <EditPhoneInput name='mobile' label={messages.mobileLabel} qa={qa} />

                    <EditPhoneInput name='directDial' label={messages.directDialLabel} qa={qa} />

                    <TextField
                        name='skypeName'
                        qa={domHelpers.generateDataQa(qa, 'skype')}
                        label={messages.skypeNameLabel}
                        placeholder={messages.skypeNamePlaceholder}
                        maxLength={constants.xeroConstants.SKYPE_MAX_LENGTH}
                    />

                    <TextField
                        name='website'
                        qa={domHelpers.generateDataQa(qa, 'website')}
                        label={messages.websiteLabel}
                        placeholder={messages.websitePlaceholder}
                    />
                </Grid>
            </Grid>
        </Form.Part>
    );
};

ContactInformationSection.displayName = 'ContactInformationSection';
